import styled from "@emotion/styled";
import {
  grayScale,
  mHeader1,
  mHeader2,
  wBody2,
  wHeader2,
  wTitle1,
} from "@teamsparta/design-system";

import { DESKTOP } from "@/themes/device";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 328px;
  ${DESKTOP} {
    width: initial;
  }
`;

export const Title = styled.h1`
  ${mHeader1};
  font-size: 23px;
  color: ${grayScale.white} !important;
  ${DESKTOP} {
    ${wHeader2};
    text-align: center;
  }
`;

export const Content = styled.div`
  display: grid;
  gap: 50px;
  margin: 40px auto 0;
  ${DESKTOP} {
    gap: 60px 80px;
    grid-template-columns: repeat(2, 1fr);
    width: 741px;
    margin-top: 80px;
  }
`;

export const Marketer = styled.div``;
export const MarketerTitle = styled.h3`
  ${mHeader2};
  color: ${grayScale.white} !important;
  margin: 24px 0 12px;
  ${DESKTOP} {
    ${wTitle1};
    margin: 36px 0 16px;
  }
`;
export const MarketerDesc = styled.p`
  ${wBody2};
  color: #e0e8ec !important;
  white-space: pre-wrap;
`;
